import IconButton from '@material-ui/core/IconButton';
import { Container } from 'react-bootstrap';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LanguageIcon from '@material-ui/icons/Language';

export default function Follow() {
    return (
        <section id="Follow Us">
            <Container className="faq-container">
                <h1>Follow Us</h1>

                <div className="followus-container">
                    <a href="https://www.facebook.com/SchoolofAIAlgiers/" target="_blank" rel="noreferrer">
                        <IconButton
                            className="followus-btn" aria-label=" " component="span">
                            <FacebookIcon />
                        </IconButton>
                    </a>
                    <a href="https://www.instagram.com/school_of_ai.algiers/" target="_blank" rel="noreferrer">
                        <IconButton
                            className="followus-btn" aria-label=" " component="span">
                            <InstagramIcon />
                        </IconButton>
                    </a>
                    <a href="https://fr.linkedin.com/company/school-of-ai-algiers" target="_blank" rel="noreferrer">
                        <IconButton
                            className="followus-btn" aria-label=" " component="span">
                            <LinkedInIcon />
                        </IconButton>
                    </a>
                    <a href="https://twitter.com/soaialgiers" target="_blank" rel="noreferrer">
                        <IconButton
                            className="followus-btn" aria-label=" " component="span">
                            <TwitterIcon />
                        </IconButton>
                    </a>
                    <a href="https://m.youtube.com/channel/UChFa3XnZYZ94tkjfJ5CnPOA" target="_blank"  rel="noreferrer">
                        <IconButton
                            className="followus-btn" aria-label=" " component="span">
                            <YouTubeIcon />
                        </IconButton>
                    </a>
                    <a href="http://algierschoolofai.tech/" target="_blank"  rel="noreferrer" >
                        <IconButton
                            className="followus-btn" aria-label=" " component="span">
                            <LanguageIcon />
                        </IconButton>
                    </a>
                </div>
                <div className="rights-container"><h4>© 2020 School of AI - Algiers - . All Rights Reserved.</h4></div>

            </Container>
        </section>
    )
}